import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createForm: false,
  editObj: null,
  report: false,
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    showCreateForm: (state) => {
      state.createForm = !state.createForm;
    },
    showReportForm: (state) => {
      state.report = !state.report;
    },

    setProductObj: (state, { payload }) => {
      state.editObj = payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { showCreateForm, setProductObj, showReportForm } =
  productSlice.actions;
export default productSlice.reducer;
